var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout",staticStyle:{"min-height":"100vh"}},[_c('nuxt'),_vm._v(" "),_c('GlobalLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }